import { render, staticRenderFns } from "./brandListBottom.vue?vue&type=template&id=3d46dc9c&scoped=true&"
import script from "./brandListBottom.vue?vue&type=script&lang=js&"
export * from "./brandListBottom.vue?vue&type=script&lang=js&"
import style0 from "./brandListBottom.vue?vue&type=style&index=0&id=3d46dc9c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d46dc9c",
  null
  
)

export default component.exports